import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './Custom.module.scss';

const CustomButton = ({ iconClassName, onClick, className, color, children, processing, disabled, ...props }) => (
  <button
    type="button"
    className={cn(styles.button, className, { [styles[color]]: !!color, [styles.processing]: processing })}
    onClick={onClick}
    disabled={processing || disabled}
    {...props}
  >
    {processing ? <div className={cn('spinner-border text-light', styles.spinner)} /> : <i className={iconClassName} />}
    {children}
  </button>
);

CustomButton.propTypes = {
  onClick: PropTypes.func,
  iconClassName: PropTypes.string,
  color: PropTypes.oneOf(['white', 'red', 'green']),
  className: PropTypes.string,
  children: PropTypes.node
};

CustomButton.defaultProps = {
  onClick() {},
  className: '',
  iconClassName: '',
  color: null,
  children: null
};

export default CustomButton;
